/*!
 * Vente Attribution Hub: touchpoint capture v2.0
 *
 * Keeps the visitor's journey in localStorage (no 4 KB cookie limit) and writes it to the cart as hidden
 * attributes, which Shopify copies onto the order:
 *   _vah_j   journey JSON (format v2):
 *            {"v":2, "vid":"<device visitor id>", "oc":<orders already placed on this device>,
 *             "lo":<unix ts of the last order or 0>, "lf":[lifetime first touch], "n":<touches this journey>,
 *             "t":[[touch], ...]}      t = touches since the last order (first, up to maxMiddle middle, last)
 *   _vah_ga  GA4 client id from the _ga cookie
 * Repeat purchases: the checkout_completed custom pixel (theme/vc-hub-pixel.js) writes vah_order_done to
 * localStorage; on the next page view this script closes the journey and starts a new one, keeping lf.
 *
 * Touch array field order. Keep in sync with TOUCH_FIELDS in function/main.py:
 *   0 ts (unix seconds)  1 src  2 med  3 cmp  4 cnt  5 trm  6 uid (utm_id)  7 ctype (click id name)
 *   8 cval (click id)    9 dev  10 br  11 ai (0/1)  12 re (tab re-entry 0/1)  13 lp (landing path)  14 ref (referrer host)
 *
 * Install: Online Store > Themes > Edit code > Assets > add vc-hub.js, then in layout/theme.liquid before </head>:
 *   <script src="{{ 'vc-hub.js' | asset_url }}" defer></script>
 * The file name is deliberately neutral; names containing "attribution" or "tracking" are more likely to be
 * blocked by browser filter lists.
 */
(function () {
  'use strict';
  if (window.__vahLoaded) return;
  window.__vahLoaded = true;

  // Per-brand settings. Change only these.
  var CFG = {
    sessionTimeoutMin: 30,   // a visit after this much inactivity starts a new touch
    maxMiddle: 100,          // middle touches kept between first and last (about 200 characters each)
    maxAttrChars: 30000,     // _vah_j is trimmed (oldest middle touches first) to fit; stay under 60000
    legacyCookie: 'st_mta',  // earlier capture script's cookie: its touches are imported once, then it is deleted
    // Consent mode (analytics consent, read from Shopify's Customer Privacy API or window.VAH_consent):
    //   'opt_in'  nothing runs (no storage, no cart writes) until consent is given. Fails closed if the API never loads.
    //   'opt_out' runs by default (implied consent); stops and erases its data if the shopper declines or withdraws.
    //   'off'     ignores consent (only where the brand's counsel has confirmed no consent is needed)
    consentMode: 'opt_out',
    internalHosts: []        // extra hosts that are part of the site, e.g. ['blog.brand.com']
  };

  var K_JOURNEY = 'vah_journey', K_ORDER = 'vah_order_done', K_SEEN = 'vah_last_seen', K_SYNC = 'vah_synced', K_HIDDEN = 'vah_hidden_at';
  // Source/medium vocabulary matches the original NYH/PHD capture script, so existing Hub channel rules apply.
  // Hosts that appear as referrer when a shopper returns from checkout, payment or login; never a new touch.
  var IGNORE_REF = /(^|\.)(shopify\.com|shop\.app|myshopify\.com|paypal\.com|klarna\.com|afterpay\.com|affirm\.com|sezzle\.com|pay\.google\.com|apple\.com)$/i;
  var SEARCH = /(^|\.)(google\.[a-z.]+|bing\.com|duckduckgo\.com|yahoo\.com|ecosia\.org|baidu\.com|yandex\.[a-z.]+|search\.brave\.com)$/i;
  var SOCIAL = /(^|\.)(facebook\.com|instagram\.com|pinterest\.[a-z.]+|tiktok\.com|twitter\.com|x\.com|t\.co|linkedin\.com|reddit\.com|youtube\.com)$/i;
  // A person clicked a link in an AI answer -> medium ai_referral, source = platform
  var AI_REFERRERS = [
    [/(^|\.)(chatgpt\.com|chat\.openai\.com)$/i, 'chatgpt'], [/(^|\.)perplexity\.ai$/i, 'perplexity'],
    [/^gemini\.google\.com$/i, 'gemini'], [/(^|\.)claude\.ai$/i, 'claude'], [/^copilot\.microsoft\.com$/i, 'copilot']
  ];
  // An AI agent loading the page itself (best effort: many agents use ordinary browser user agents)
  var AI_AGENTS = [
    [/ChatGPT-User|OAI-SearchBot|ChatGPT Agent/, 'chatgpt'], [/Claude-User|Claude-SearchBot/, 'claude'],
    [/Perplexity-User|PerplexityBot/, 'perplexity']
  ];
  // [param, source when no utm_source]; medium defaults to cpc
  var CLICK_IDS = [
    ['gclid', 'google_ads'], ['gbraid', 'google_ads'], ['wbraid', 'google_ads'], ['dclid', 'google_ads'],
    ['fbclid', 'meta'], ['msclkid', 'microsoft_ads'], ['ttclid', 'tiktok'], ['epik', 'pinterest'],
    ['pin_click_id', 'pinterest'], ['twclid', 'x'], ['li_fat_id', 'linkedin'], ['sccid', 'snapchat'], ['rdt_cid', 'reddit']
  ];

  // ── small helpers ──────────────────────────────────────────────────────────
  function store(kind) {
    try { var s = window[kind]; s.setItem('__vah', '1'); s.removeItem('__vah'); return s; } catch (e) { return null; }
  }
  var LS = store('localStorage'), SS = store('sessionStorage');
  function get(s, k) { try { return s ? s.getItem(k) : null; } catch (e) { return null; } }
  function set(s, k, v) { try { if (s) s.setItem(k, v); } catch (e) {} }
  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function cut(v, n) { if (v == null || v === '') return null; v = String(v); return v.length > n ? v.slice(0, n) : v; }
  function now() { return Math.floor(Date.now() / 1000); }
  function bare(h) { return (h || '').toLowerCase().replace(/^www\./, ''); }
  function hash(s) { var h = 0; for (var i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0; return String(h); }

  function isInternal(host) {
    var h = bare(host), me = bare(location.hostname);
    if (!h) return true;
    if (h === me || h.slice(-(me.length + 1)) === '.' + me || me.slice(-(h.length + 1)) === '.' + h) return true;
    for (var i = 0; i < CFG.internalHosts.length; i++) if (h === bare(CFG.internalHosts[i])) return true;
    return false;
  }
  function referrerHost() {
    if (!document.referrer) return null;
    try { return new URL(document.referrer).hostname.toLowerCase(); } catch (e) { return null; }
  }
  function device() {
    var ua = navigator.userAgent;
    if (/iPad|Tablet|Android(?!.*Mobile)/i.test(ua)) return 'tablet';
    if (/Mobi|iPhone|Android/i.test(ua)) return 'mobile';
    return 'desktop';
  }
  function browser() {
    var ua = navigator.userAgent;
    if (/FBAN|FBAV|Instagram/.test(ua)) return 'meta_in_app';
    if (/TikTok|musical_ly|BytedanceWebview/i.test(ua)) return 'tiktok_in_app';
    if (/Edg\//.test(ua)) return 'edge';
    if (/OPR\//.test(ua)) return 'opera';
    if (/SamsungBrowser/.test(ua)) return 'samsung';
    if (/CriOS|Chrome\//.test(ua)) return 'chrome';
    if (/FxiOS|Firefox\//.test(ua)) return 'firefox';
    if (/Safari\//.test(ua)) return 'safari';
    return 'other';
  }
  function gaClientId() {
    var g = cookie('_ga');
    if (!g) return '';
    var p = g.split('.');
    return p.length >= 4 ? p.slice(-2).join('.') : '';
  }

  // ── journey ────────────────────────────────────────────────────────────────
  function newId() {
    try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
    return 'v' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  }

  function blank() { return { v: 2, vid: newId(), oc: 0, lo: 0, lf: null, n: 0, t: [] }; }

  function saveJourney(j) { set(LS, K_JOURNEY, JSON.stringify(j)); }

  // Converts the earlier script's cookie journey (array of objects) into v2 touches, once.
  function importLegacy() {
    var raw = CFG.legacyCookie && cookie(CFG.legacyCookie);
    if (!raw) return null;
    document.cookie = CFG.legacyCookie + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    try {
      var items = JSON.parse(raw), j = blank();
      for (var i = 0; i < items.length; i++) {
        var o = items[i], rh = null;
        try { rh = o.referrer ? new URL(o.referrer).hostname : null; } catch (e) {}
        j.t.push([Math.floor(Date.parse(o.ts) / 1000) || now(), o.utm_source || null, o.utm_medium || null,
          o.utm_campaign || null, o.utm_content || null, o.utm_term || null, null, o.click_id_type || null,
          o.click_id_value || null, o.device_type || null, o.browser || null, o.is_ai_agent ? 1 : 0,
          o.is_tab_reentry ? 1 : 0, o.landing_page || null, rh]);
      }
      j.n = j.t.length; j.lf = j.t[0] || null;
      return j.t.length ? j : null;
    } catch (e) { return null; }
  }

  function readJourney() {
    var j = null;
    try { j = JSON.parse(get(LS, K_JOURNEY)); } catch (e) {}
    var changed = false;
    if (j && j.v === 1 && j.t) {                          // upgrade a v1 journey in place
      j = { v: 2, vid: newId(), oc: 0, lo: 0, lf: j.t[0] || null, n: j.n || j.t.length, t: j.t };
      changed = true;
    }
    if (!j || !j.t) { j = importLegacy() || blank(); changed = true; }
    if (!j.vid) { j.vid = newId(); changed = true; }
    if (changed) saveJourney(j);                          // keeps the visitor id stable across page views
    return j;
  }

  // The checkout_completed pixel leaves {ts, id} in localStorage. Close the journey that led to that order.
  function closeOrderedJourney() {
    var done = null;
    try { done = JSON.parse(get(LS, K_ORDER)); } catch (e) {}
    if (!done || !done.ts) return;
    var j = readJourney();
    if (done.ts > (j.lo || 0)) {
      if (!j.lf && j.t.length) j.lf = j.t[0];
      j.oc = (j.oc || 0) + 1; j.lo = done.ts; j.n = 0; j.t = [];
      saveJourney(j);
      set(SS, K_SYNC, '');
    }
  }

  function aiAgent() {
    var ua = navigator.userAgent || '';
    for (var i = 0; i < AI_AGENTS.length; i++) if (AI_AGENTS[i][0].test(ua)) return AI_AGENTS[i][1];
    return navigator.webdriver ? 'automated' : null;
  }

  // Priority: UTM > ad click id > AI agent > classified referrer > returning visitor (tab re-entry) > direct.
  // fromVisibility: tab came back into view after 30+ min, so the URL and referrer are stale and ignored.
  function buildTouch(fromVisibility, hasHistory) {
    var p = new URLSearchParams(fromVisibility ? '' : location.search);
    var ref = fromVisibility ? null : referrerHost();
    var extRef = ref && !isInternal(ref) && !IGNORE_REF.test(ref) ? ref : null;
    var agent = aiAgent();
    var src = p.get('utm_source'), med = p.get('utm_medium'), ctype = null, cval = null, i;
    for (i = 0; i < CLICK_IDS.length; i++) {
      var v = p.get(CLICK_IDS[i][0]);
      if (v) { ctype = CLICK_IDS[i][0]; cval = v; break; }
    }
    if (!src && ctype) { src = CLICK_IDS[i][1]; med = med || 'cpc'; }
    if (!src && agent && agent !== 'automated') { src = agent; med = 'ai_agent'; }
    if (!src && extRef) {
      for (var k = 0; k < AI_REFERRERS.length; k++) {
        if (AI_REFERRERS[k][0].test(extRef)) { src = AI_REFERRERS[k][1]; med = 'ai_referral'; break; }
      }
      if (!src) { src = extRef; med = SEARCH.test(extRef) ? 'organic_search' : SOCIAL.test(extRef) ? 'organic_social' : 'referral'; }
    }
    var signal = !!(src || ctype);
    var reentry = !signal && hasHistory;
    if (!src) { src = reentry ? 'returning_visitor' : 'direct'; med = reentry ? 'tab_reentry' : 'none'; }
    var t = [
      now(), cut(src, 100), cut(med || '(not set)', 100), cut(p.get('utm_campaign'), 150),
      cut(p.get('utm_content'), 150), cut(p.get('utm_term'), 100), cut(p.get('utm_id'), 60),
      ctype, cut(cval, 150), device(), browser(), agent ? 1 : 0,
      reentry ? 1 : 0, cut(location.pathname, 150), cut(extRef, 100)
    ];
    t.signal = signal;
    return t;
  }

  function signature(t) { return [t[1], t[2], t[3], t[4], t[5], t[6], t[8]].join('|'); }

  // Returns true when a new touch was added. A touch is recorded at the start of each visit
  // (30 min inactivity, tracked in localStorage so new tabs don't count), and mid-visit only when a
  // different campaign/referrer arrives. Repeated click ids from link decoration match the last touch and are skipped.
  function record(fromVisibility) {
    var j = readJourney(), last = j.t[j.t.length - 1];
    var t = buildTouch(fromVisibility, j.t.length > 0 || !!j.lf);
    var seen = parseInt(get(LS, K_SEEN) || '0', 10);
    var expired = now() - seen > CFG.sessionTimeoutMin * 60;
    set(LS, K_SEEN, String(now()));

    var isNew = !last || fromVisibility || expired || (t.signal && signature(last) !== signature(t));
    if (!isNew) return false;
    var signal = t.signal; delete t.signal;
    if (!signal && !fromVisibility && !expired) return false;

    j.t.push(t);
    j.n = (j.n || 0) + 1;
    if (!j.lf) j.lf = t;                                 // first touch ever seen on this device
    var keep = CFG.maxMiddle + 2;                       // first + middle + last
    if (j.t.length > keep) j.t.splice(1, j.t.length - keep);
    saveJourney(j);
    return true;
  }

  function encode() {
    var j = readJourney(), t = j.t.slice(), s;
    for (;;) {
      s = JSON.stringify({ v: 2, vid: j.vid, oc: j.oc || 0, lo: j.lo || 0, lf: j.lf, n: j.n || t.length, t: t });
      if (s.length <= CFG.maxAttrChars || t.length <= 2) return s;
      t.splice(1, 1);                                    // drop the oldest middle touch
    }
  }

  // ── cart sync ──────────────────────────────────────────────────────────────
  var rawFetch = window.fetch ? window.fetch.bind(window) : null;
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  function sync(force) {
    if (!ACTIVE || !rawFetch || !LS) return;
    var cart = cookie('cart');
    if (!cart && !force) return;                       // no cart yet: nothing to attach to
    var payload = encode(), ga = gaClientId(), content = hash(payload + ga);
    if (!force && get(SS, K_SYNC) === cart + '|' + content) return;
    var body = new URLSearchParams();
    body.append('attributes[_vah_j]', payload);
    body.append('attributes[_vah_ga]', ga);
    rawFetch(root() + 'cart/update.js', {
      // keepalive requests are capped at 64 KB by browsers, so large journeys go without it
      method: 'POST', body: body, credentials: 'same-origin', keepalive: payload.length < 60000, headers: { Accept: 'application/json' }
    }).then(function (r) {
      if (r.ok) set(SS, K_SYNC, (cookie('cart') || '') + '|' + content);
    }).catch(function () {});
  }
  function syncSoon() { setTimeout(function () { sync(true); }, 300); }
  var CART_WRITE = /\/cart\/(add|change|clear)(\.js)?/;

  function hookCart() {
    if (rawFetch) {
      window.fetch = function (input, init) {
        var res = rawFetch(input, init);
        try {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          if (CART_WRITE.test(url)) res.then(syncSoon, function () {});
        } catch (e) {}
        return res;
      };
    }
    var xOpen = XMLHttpRequest.prototype.open, xSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__vahCart = CART_WRITE.test(String(url || ''));
      return xOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this.__vahCart) this.addEventListener('load', syncSoon);
      return xSend.apply(this, arguments);
    };
    // Last chance before checkout (cart page button, drawer button, accelerated buttons on the cart).
    document.addEventListener('click', function (e) {
      var el = e.target && e.target.closest &&
        e.target.closest('[name="checkout"], a[href*="/checkout"], .shopify-payment-button, [data-shopify="payment-button"]');
      if (el) sync(true);
    }, true);
  }

  function watchTabReentry() {
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        set(SS, K_HIDDEN, String(now()));
        set(LS, K_SEEN, String(now()));
        return;
      }
      if (!ACTIVE) return;
      var hiddenAt = parseInt(get(SS, K_HIDDEN) || '0', 10);
      set(SS, K_HIDDEN, '');
      if (hiddenAt && now() - hiddenAt >= CFG.sessionTimeoutMin * 60) { closeOrderedJourney(); if (record(true)) sync(false); }
    });
  }

  // ── consent + start ────────────────────────────────────────────────────────
  var ACTIVE = false, STARTED = false;

  function start() {
    if (ACTIVE || !LS) return;
    ACTIVE = true;
    set(SS, 'vah_erased', '');
    closeOrderedJourney();
    record(false);
    if (!STARTED) { STARTED = true; hookCart(); watchTabReentry(); }
    sync(false);
  }

  // Consent declined or withdrawn: stop, erase this script's storage and clear the cart attributes.
  function stopAndErase() {
    var wasActive = ACTIVE;
    ACTIVE = false;
    var keys = [K_JOURNEY, K_ORDER, K_SEEN];
    for (var i = 0; i < keys.length; i++) { try { if (LS) LS.removeItem(keys[i]); } catch (e) {} }
    try { if (SS) { SS.removeItem(K_SYNC); SS.removeItem(K_HIDDEN); } } catch (e) {}
    if ((wasActive || (cookie('cart') && get(SS, 'vah_erased') !== '1')) && rawFetch) {
      set(SS, 'vah_erased', '1');
      var body = new URLSearchParams();
      body.append('attributes[_vah_j]', '');             // an empty value removes the attribute
      body.append('attributes[_vah_ga]', '');
      rawFetch(root() + 'cart/update.js', { method: 'POST', body: body, credentials: 'same-origin', keepalive: true })
        .catch(function () {});
    }
  }

  function apply(allowed) { if (allowed) start(); else stopAndErase(); }

  // For consent managers not wired into Shopify's Customer Privacy API: set window.VAH_consent = true/false
  // before this script loads, and call window.VAH_setConsent(true|false) whenever the shopper changes it.
  window.VAH_setConsent = function (allowed) { window.VAH_consent = !!allowed; apply(!!allowed); };

  function shopifyAllowed() {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed(); } catch (e) { return null; }
  }

  function initConsent() {
    var mode = CFG.consentMode;
    if (mode === 'off') return start();
    if (typeof window.VAH_consent === 'boolean') return apply(window.VAH_consent);
    if (mode === 'opt_out' && shopifyAllowed() !== false) start();   // implied consent unless already declined

    // Later changes from Shopify's banner or a connected consent manager
    document.addEventListener('visitorConsentCollected', function (ev) {
      if (typeof window.VAH_consent === 'boolean') return;
      var allowed = ev && ev.detail && typeof ev.detail.analyticsAllowed === 'boolean'
        ? ev.detail.analyticsAllowed : shopifyAllowed();
      if (allowed !== null) apply(allowed);
    });

    function check() {
      if (typeof window.VAH_consent === 'boolean') return;
      var allowed = shopifyAllowed();
      if (allowed === true) start();
      else if (allowed === false && mode === 'opt_out') stopAndErase();   // opt_in: stay off, wait for the event
    }
    try {
      if (window.Shopify && window.Shopify.customerPrivacy) check();
      else if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) check(); });
      }
      // No API at all: opt_in stays off (fails closed); opt_out keeps running.
    } catch (e) {}
  }

  initConsent();
})();
